import { StorageImpl } from './storage.service';
import { Router } from '@angular/router';

export function createPersistentStorage(router: Router, PLATFORM_ID: Object) {
  return new StorageImpl(window.localStorage, router, PLATFORM_ID);
}

export function createSessionStorage(router: Router, PLATFORM_ID: Object) {
  return new StorageImpl(window.sessionStorage, router, PLATFORM_ID);
}
